import React from "react";
import ApiEndpointBlock from "../components/ApiEndpointBlock";

const ApiDocsPage = () => {
    return (
        <div className="max-w-4xl mx-auto p-6 bg-white rounded shadow mt-6 mb-12 text-gray-800">
            <h1 className="text-3xl font-bold text-brand-blue mb-4">
                🧾 Documentación Técnica — API Pública de Reformista.net
            </h1>

            <p className="mb-6">
                Bienvenido a la API pública de <strong>Reformista.net</strong>. Esta documentación está pensada para ayudar a desarrolladores e integradores a conectar con nuestros servicios y obtener cálculos detallados de reformas y rentabilidad para propiedades.
            </p>

            <div className="bg-gray-100 p-4 rounded border-l-4 border-blue-500 mb-6">
                <h3 className="font-semibold text-blue-700 mb-1">🔐 Autenticación mediante API Key</h3>
                <p className="text-sm text-gray-700">
                    Para utilizar esta API necesitas una <strong>clave de cliente</strong> (<code>x-client-id</code>) y una <strong>clave de acceso</strong> (<code>x-api-key</code>), que deben enviarse en las cabeceras de cada petición.
                </p>
                <ul className="list-disc list-inside text-sm mt-2 text-gray-600">
                    <li><code>x-client-id</code>: identificador único del cliente</li>
                    <li><code>x-api-key</code>: clave privada de acceso (proporcionada tras validación)</li>
                </ul>
                <p className="mt-3 text-sm">
                    Puedes solicitar tu clave completando el siguiente formulario:{" "}
                    <a
                        href="https://reformista.net/solicitar-api-key"
                        className="text-brand-blue underline"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        https://reformista.net/solicitar-api-key
                    </a>
                </p>
            </div>

            <hr className="my-6" />

            <h2 className="text-2xl font-semibold mb-4">📘 Endpoints disponibles</h2>

            <ApiEndpointBlock
                title="🔹 1. Cálculo estimado de reforma"
                method="POST"
                path="/api/v1/external/reformas/calcular"
                url="https://api.reformista.net/api/v1/external/reformas/calcular"
                description="Obtiene el coste estimado de reforma para una propiedad en distintos escenarios (estándar, premium...), con todos los constructores disponibles."
                auth={`x-client-id: TU_CLIENT_ID
x-api-key: TU_API_KEY`}
                request={`{
  "superficie": 90,
  "habitaciones": 3,
  "banos": 2
}`}
                response={`[ { "constructor_nombre": "Reformas Elite", "reformas": [ ... ] } ]`}
            />

            <ApiEndpointBlock
                title="🔹 2. Cálculo de indicadores de inversión"
                method="POST"
                path="/api/v1/external/indicadores-inversion/calcular"
                url="https://api.reformista.net/api/v1/external/indicadores-inversion/calcular"
                description="Calcula los indicadores de rentabilidad (ROI, alquiler, retorno) para una propiedad dada."
                auth={`x-client-id: TU_CLIENT_ID
x-api-key: TU_API_KEY`}
                request={`{
  "superficie": 90,
  "habitaciones": 3,
  "banos": 2,
  "id_localizacion": 8,
  "precio": 100000,
  "operacionesLista": ["venta", "alquiler", "alquiler vacacional"]
}`}
                response={`{ "propiedad": { ... }, "escenarios": { ... } }`}
            />

            <ApiEndpointBlock
                title="🔹 3. Calcular costes extra de alquiler vacacional"
                method="POST"
                path="/api/v1/external/alquiler-vacacional/calcular-costes-extra"
                url="https://api.reformista.net/api/v1/external/alquiler-vacacional/calcular-costes-extra"
                description="Calcula los costes extra asociados al alquiler vacacional (decoración, licencias, mobiliario, electrodomésticos...) sin necesidad de tener la propiedad almacenada."
                auth={`x-client-id: TU_CLIENT_ID
x-api-key: TU_API_KEY`}
                request={`{
  "superficie": 90,
  "habitaciones": 3,
  "banos": 2
}`}
                response={`{
  "costes": {
    "detalles": { ... },
    "totalesPorCategoria": { ... },
    "costeTotal": 12345.67
  }
}`}
            />

            <ApiEndpointBlock
                title="🔹 4. Obtener localizaciones disponibles"
                method="GET"
                path="/api/v1/external/localizaciones"
                url="https://api.reformista.net/api/v1/external/localizaciones"
                description="Devuelve la lista de localizaciones con datos disponibles para simulaciones de inversión."
                auth={`x-client-id: TU_CLIENT_ID
x-api-key: TU_API_KEY`}
                response={`[
  { "id": 8, "municipio": "Granada", "distrito": "Centro" },
  { "id": 12, "municipio": "Maracena", "distrito": "-" }
]`}
            />

            <hr className="my-8" />

            <p className="text-sm text-gray-500">
                📅 Última actualización: Abril 2025 <br />
                📩 Soporte técnico: <a href="mailto:dev@reformista.net" className="text-brand-blue underline">dev@reformista.net</a>
            </p>
            <div className="mt-8">
                <a
                    href="/Reformista_API_Documentacion.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block bg-brand-blue text-white px-4 py-2 rounded hover:bg-blue-800 transition"
                >
                    📥 Descargar documentación en PDF
                </a>
            </div>
        </div>);
};

export default ApiDocsPage;
